<template>
  <div v-if="loaded && !eventError" class="container-bg-img">
    <div
      class="background-image-blur"
      :style="{
        backgroundImage:
          'url(' +
          (event?.thumbnails?.m_hor_dt
            ? event.thumbnails.m_hor_dt
            : event?.image_url) +
          ')',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
      }"
    ></div>
    <div class="overlay-bg-img"></div>
  </div>
  <profile-layout
    v-if="loaded && !eventError"
    :image="event?.image_url"
    :previsualization="!event.enabled"
    :profile="event.title"
    :medias="media"
    type="event"
    :event-type="event.type === 0 ? 'concert' : 'festival'"
    :artist="event.artists"
    :cancelation="event.cancelation_status"
    :sold-out="event?.sold_out"
    @update:open-share="openShareModal()"
    @open-gallery="
      geValidMedias(media)?.length ? (showGalleryModal = true) : '',
        (showPrincipal = true)
    "
  >
    <template #header>
      <!-- Pixels -->
      <ga-pixel
        v-if="event?.google_pixel_js"
        class="hidden"
        :pixel="event.google_pixel_js"
      />
      <fb-pixel
        v-if="event?.facebook_pixel_js"
        class="hidden"
        :pixel="event.facebook_pixel_js"
      />
      <tiktok-pixel
        v-if="event?.tiktok_pixel_js"
        class="hidden"
        :pixel="event.tiktok_pixel_js"
        type="EventProfile"
      />
      <twitter-pixel
        v-if="event?.twitter_pixel_js"
        class="hidden"
        :pixel="event.twitter_pixel_js"
      />
      <!-- End Pixels -->
      <!-- Header -->
      <div class="header flex flex-col h-full justify-between max-w-[60%]">
        <div class="content content-top">
          <live-now-section
            v-if="showLiveNow && defaultChannels[0]"
            :channel="defaultChannels[0]"
          />
          <div>
            <h1 class="title lg:w-3/5 lg:mb-[18px]">
              {{
                $t("profiles.buttons.buyTicketsFor", { event: nameFormatted })
              }}
              {{
                event.permalink.includes("vibra-mahou-fest-madrid")
                  ? ""
                  : $t("wegow.headerDetails.in", {
                      city:
                        event.city.name || event.city.administrative_division
                    })
              }}
              {{ event.type === 0 ? event.start_date.slice(0, 4) : "" }}
            </h1>
            <h2 v-if="event.subtitle" class="text-[20px] md:block hidden">
              {{ event.subtitle }}
            </h2>
          </div>

          <!-- <div
                v-if="event.price || event.price === 0"
                class="text font-museo-500 text-m xl:hidden block ml-8"
              >
                {{ $t("profiles.from") }} {{ priceFormatted }}
              </div> -->
          <div class="event">
            <a
              :href="event.venue.permalink"
              class="place text-color-topaz-light font-museo-500"
            >
              {{ event.venue.name }}, {{ event.city.name }}
            </a>
            <div
              class="date first-letter:capitalize md:text-l font-museo-500"
              :class="isFestival ? 'festival' : ''"
            >
              <span v-if="!isFestival">
                {{ startEventDate }}
              </span>
              <span v-else>
                {{ longDateFormated }}
              </span>

              <span v-if="isFestival && !sameDateFestival">
                - {{ longEndDateFormated }}</span
              >
            </div>
          </div>
          <!-- External Message -->
          <div
            v-if="isExternal"
            class="no-wegow-tickets lg:flex hidden lg:flex-row gap-2 mb-5 text-[12px]"
          >
            <icon
              :size="20"
              :img="require('@/assets/images/ic-warning-message.svg')"
            />
            <div class="flex-1">
              <div class="font-museo-700">
                {{ $t("profiles.texts.notWegowTicket") }}
              </div>
              <div>
                {{ $t("profiles.texts.priceInfo") }}
              </div>
            </div>
          </div>
          <!-- End External Message -->
          <div
            v-if="hasCulturalBonus(event, timezone)"
            class="promo text-[11px] md:text-xs xl:text-[15px] font-museo-500 flex flex-row align-middle items-center gap-3"
          >
            <icon
              :img="require('@/assets/images/cultural-bonus.png')"
              :size="28"
              class="hidden xl:block"
            />
            <icon
              :img="require('@/assets/images/cultural-bonus.png')"
              :size="16"
              class="xl:hidden block"
            />
            {{ $t("profiles.titles.culturalBonus") }}
          </div>
          <!-- Interaction buttons -->
          <div
            class="interactions lg:flex hidden items-center"
            :class="
              (!event.price || event.price !== 0) && !isZero
                ? 'justify-between'
                : 'md:gap-[28px]'
            "
          >
            <div class="purchase-container flex justify-between">
              <div
                v-if="
                  event.enabled &&
                    event.tickets_enabled &&
                    (event.ticket_types_count > 0 || event.options?.length > 0)
                "
                class="hidden payment lg:flex justify-between align-middle items-center gap-[28px]"
              >
                <!-- Price -->
                <!-- TODO: cambiar a router personalizado ¿Comprobar si tiene tickets?-->
                <div v-if="!event.queued">
                  <router-link
                    v-if="
                      event.enabled &&
                        event.tickets_enabled &&
                        event.ticket_types_count >= 0
                    "
                    :to="{
                      name: 'PurchasePage',
                      params: {
                        slug: event.slug
                      },
                      ...referenceQuery
                    }"
                  >
                    <wegow-button
                      button-id="buy-btn"
                      class="h-[58px]"
                      :text="$t('wegow.purchase.buy')"
                      background="opacity"
                      color="topaz-light"
                      size="xl"
                      font-size="xl"
                      type="button"
                    />
                  </router-link>
                </div>
                <div v-else-if="event.options.length !== 1">
                  <wegow-button
                    class="h-[58px]"
                    :text="$t('wegow.purchase.buy')"
                    background="opacity"
                    color="topaz-light"
                    size="xl"
                    font-size="xl"
                    type="button"
                    :button-id="`purchase-queued-button-${event.id}`"
                    @click="onClickQueued(event)"
                  />
                </div>
                <div v-else-if="isExternal && event.options.length === 1">
                  <single-external-purchase-button />
                </div>
                <div
                  v-if="(event.price || event.price === 0) && !isZero"
                  class="text font-museo-500 price"
                >
                  {{ $t("profiles.from") }} {{ priceFormatted }}
                </div>
              </div>
              <div
                class="lg:hidden payment flex justify-between align-middle items-center"
              >
                <!-- TODO: cambiar a router personalizado ¿Comprobar si tiene tickets?-->
                <router-link
                  v-if="
                    event.enabled &&
                      event.tickets_enabled &&
                      (event.ticket_types_count > 0 ||
                        event.options?.length > 0)
                  "
                  class="mr-0"
                  :to="{
                    name: 'PurchasePage',
                    params: {
                      slug: event.slug
                    },
                    ...referenceQuery
                  }"
                >
                  <wegow-button
                    v-if="!isExternal"
                    button-id="square-banner-purchase"
                    :text="$t('wegow.purchase.buy')"
                    background="opacity"
                    color="topaz-light"
                    size="xs"
                    type="button"
                  />
                </router-link>
              </div>
            </div>
            <div class="flex gap-2 icon-links-container">
              <icon
                class="interaction__btn transition-all"
                :img="
                  event.user.tracking
                    ? require('@/assets/images/ic-full-heart-rounded-topaz.svg')
                    : require('@/assets/images/ic-empty-heart-rounded-topaz.svg')
                "
                :size="41"
                @click="
                  isAuth ? interested(event) : openModal(SIGN_IN);
                  sendGa('sign-in');
                "
              />
              <icon
                class="interaction__btn"
                :img="require('@/assets/images/ic-followers-circle-topaz.svg')"
                :size="41"
                @click="scrollToSection('followers')"
              />
              <span
                href="#"
                class="chat-button interaction__btn"
                @click="scrollToSection('chat-section')"
              >
                <icon
                  :img="require('@/assets/images/ic-chat-circle-topaz.svg')"
                  :size="41"
                />
              </span>
              <div
                class="flex flex-col interaction__btn"
                @click="openShareModal()"
              >
                <icon
                  :img="require('@/assets/images/ic-share-circle-topaz.svg')"
                  :size="41"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End Header -->
    </template>
    <template #top-sections>
      <ol id="event-nav" class="flex flex-row justify-evenly gap-3">
        <li class="section" @click="scrollToSection('event-information')">
          {{ $t("profiles.titles.information") }}
        </li>
        <li class="section" @click="scrollToSection('event-accommodation')">
          {{ $t("profiles.titles.accommodation") }}
        </li>
        <li class="section" @click="scrollToSection('how-to-get')">
          {{ $t("profiles.titles.howToGet") }}
        </li>
        <!-- <li class="section" @click="scrollToSection('transport-section')">
          {{ $t("profiles.titles.transport") }}
        </li> -->
        <!-- <li
          v-if="isChatEnabled"
          class="section"
          @click="scrollToSection('chat-section')"
        >
          {{ $t("profiles.titles.chat") }}
        </li> -->
      </ol>
    </template>
    <template #content>
      <!-- External Sell -->
      <section
        v-if="isExternal && event.options.length > 1"
        id="wegow__event__tickets"
        class="section-container is-external relative p-3 two-col"
      >
        <external-options-list
          :is-profile="true"
          @primary="primaryOptionsZero($event)"
        />
      </section>

      <!-- End External Sell -->
      <!-- External Mobile Message -->
      <section
        v-if="isExternal"
        class="no-wegow-tickets no-wegow-tickets-mobile flex lg:hidden :flex-row gap-2 section-container two-col m-3 bg-valhalla p-[14px] rounded-[10px]"
      >
        <svg
          width="21"
          height="21"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.6387 2.56689H8.63867C5.32967 2.56689 2.63867 5.25789 2.63867 8.56689V16.5669C2.63867 19.8759 5.32967 22.5669 8.63867 22.5669H21.6387C21.9039 22.5669 22.1582 22.4615 22.3458 22.274C22.5333 22.0865 22.6387 21.8321 22.6387 21.5669V8.56689C22.6387 5.25789 19.9477 2.56689 16.6387 2.56689ZM8.63867 20.5669C6.43267 20.5669 4.63867 18.7729 4.63867 16.5669V8.56689C4.63867 6.36089 6.43267 4.56689 8.63867 4.56689H16.6387C18.8447 4.56689 20.6387 6.36089 20.6387 8.56689V20.5669H8.63867ZM11.6387 6.56689H13.6387V14.5669H11.6387V6.56689ZM11.6387 16.5669H13.6387V18.5669H11.6387V16.5669Z"
            fill="#2EFFEC"
          />
        </svg>
        <div class="flex-1 text-[12px]">
          <p>
            {{ $t("profiles.texts.notWegowTicket") }}
          </p>
          <p>
            {{ $t("profiles.texts.priceInfo") }}
          </p>
        </div>
      </section>
      <!-- End External Mobile Message -->
      <!-- <section v-if="event.access_policy" class="two-col">
        <minor-regulation />
      </section> -->
      <!-- Information -->
      <w-shadow>
        <template #contain>
          <article
            id="event-information"
            class="section-container information-section"
          >
            <h3 class="h3-titles font-museo-500 mb-8">
              <span v-if="deleteConcertsWord">
                {{ $t("profiles.labels.eventInformationOf") }}
                {{ nameFormatted }}</span
              >
              <span v-else-if="event.type === 0">
                {{ $t("profiles.labels.concertInformationOf") }}
                {{ nameFormatted }}
              </span>

              <span v-else-if="event.type === 1">
                {{ $t("profiles.labels.festivalInformationOf") }}
                {{ nameFormatted }}</span
              >
              <span v-else-if="event.type === 2">
                {{ $t("profiles.labels.sessionInformationOf") }}
                {{ nameFormatted }}
              </span>
              <span v-else>
                {{ $t("profiles.labels.partyInformationOf") }}
                {{ nameFormatted }}
              </span>
              {{ $t("profiles.in") }} {{ event.city.name }}
            </h3>
            <div
              class="info flex flex-col text-color-gray gap-2 md:text-s text-[12px] mb-10"
            >
              <div>
                {{ $t("wegow.filters.date") }}
                <span>{{ longDateFormated }}</span>
                <span v-if="isFestival"> - {{ longEndDateFormated }}</span>
              </div>

              <div>
                {{ $t("profiles.labels.hour") }}
                <span>{{ hourFormatted }}h</span>
              </div>
              <div
                v-if="
                  event.opening_hour && event.opening_hour !== event.start_date
                "
              >
                {{ $t("profiles.labels.doorOpen") }}
                <span>{{ hourOpenFormatted }}h</span>
              </div>

              <div>
                {{ $t("profiles.labels.place") }}
                <span>{{ event.venue.name }}, </span>
                <span>{{
                  event.city.name || event.city?.administrative_division
                }}</span>
              </div>
              <div
                v-if="event?.artists?.length > 0 && event?.artists?.length < 3"
              >
                {{ $t("profiles.titles.artists") }}
                <a
                  v-for="(artist, index) in orderArtists"
                  :key="artist.id"
                  :href="artist.permalink"
                >
                  <span class="text-topaz-light">{{ artist.name }}</span>
                  <span v-if="index !== event.artists.length - 1">, </span>
                </a>
              </div>
              <div v-if="event.price || event.price === 0">
                {{ $t("profiles.labels.anticipatedPrice") }}
                <span>{{ priceFormatted }}</span>
              </div>
              <div class="block md:hidden">
                <h2 v-if="event.subtitle" class="text-[15px] text-color-white">
                  {{ event.subtitle }}
                </h2>
              </div>
              <!-- TODO: revisar cual es la diferencia entre precio en taquilla y precio anticipado -->
              <!-- <div>
            {{ $t("profiles.labels.boxOffice") }}
            <span>{{}}</span>
          </div> -->
            </div>
            <div class="h3-titles font-museo-500">
              <p>{{ $t("profiles.labels.descriptionInformationOf") }}</p>
            </div>
            <show-more
              v-if="event?.html_personalization?.html_description"
              :html-personalization="true"
              :text="event?.html_personalization?.html_description"
              :max-words="30"
              class="mt-4 mb-4 description__html"
            />
            <show-more
              v-else
              :text="event.description"
              :max-words="30"
              class="mt-4 mb-4"
            />
            <social-media
              v-if="event.links.length > 0"
              :facebook="
                formatSocialMediaUrl(event.links).facebook
                  ? formatSocialMediaUrl(event.links).facebook
                  : ''
              "
              :instagram="
                formatSocialMediaUrl(event.links)?.instagram
                  ? formatSocialMediaUrl(event.links).instagram
                  : ''
              "
              :medias-to-show="formatSocialMedia(event.links)"
              :spotify="
                formatSocialMediaUrl(event.links).spotify
                  ? formatSocialMediaUrl(event.links).spotify
                  : ''
              "
              :twitter="
                formatSocialMediaUrl(event.links).twitter
                  ? formatSocialMediaUrl(event.links).twitter
                  : ''
              "
              :web="
                formatSocialMediaUrl(event.links).web
                  ? formatSocialMediaUrl(event.links).web
                  : ''
              "
              :youtube="
                formatSocialMediaUrl(event.links).youtube
                  ? formatSocialMediaUrl(event.links).youtube
                  : ''
              "
              :tiktok="
                formatSocialMediaUrl(event.links).tiktok
                  ? formatSocialMediaUrl(event.links).tiktok
                  : ''
              "
              :soundcloud="
                formatSocialMediaUrl(event.links).soundcloud
                  ? formatSocialMediaUrl(event.links).soundcloud
                  : ''
              "
              :other="
                formatSocialMediaUrl(event.links).other
                  ? formatSocialMediaUrl(event.links).other
                  : ''
              "
              :rounded="0"
            />
            <div class="mt-4">
              <Suspense>
                <template #default>
                  <modal-report :object-id="event.id" type="event" />
                </template>
                <template #fallback>
                  <wegow-loader class="min-h-screen" />
                </template>
              </Suspense>
            </div>
          </article>
        </template>
      </w-shadow>
      <!-- Related Section -->
      <smart-clip
        v-if="showAds"
        class="two-col inline md:hidden m-auto"
        :type="'sc-mpu-extra'"
      />
      <section
        class="related-container section-container"
        :class="{
          'no-paddings': windowWidth < 475
        }"
      >
        <div v-if="eventsRelatedToEvent?.events?.length" class="relative">
          <related-events></related-events>
        </div>
        <div v-if="artistsRelatedToEvent?.length" class="relative mt-8">
          <related-artists
            :artists-related="artistsRelatedToEvent"
          ></related-artists>
        </div>
        <div v-if="venuesRelatedToEvent?.length" class="relative mt-8">
          <div class="slider-gradient bottom-0"></div>
          <related-venues
            :venues-related="venuesRelatedToEvent"
          ></related-venues>
        </div>
      </section>
      <!-- Artist cartel -->
      <artists-section v-if="event?.artists?.length > 2" />
      <!-- Followers -->
      <w-shadow>
        <template #contain>
          <section
            id="followers"
            class="section-container followers-container relative"
            :class="{
              'no-paddings': windowWidth < 475
            }"
          >
            <followers-section
              :profile-followers="eventFollowers"
              :followers-count="event.followers_count"
              @open-followers="showFollowersModal = true"
            ></followers-section>
          </section>
        </template>
      </w-shadow>

      <!-- Chat -->
      <section
        id="chat-section"
        class="section-container chat-container p-3 md:p-0"
      >
        <h3 class="h3-titles has-show-more">
          {{ $t("profiles.titles.chat") }}
        </h3>
        <p class="text-[12px]">
          {{ $t("wegow.chat.subtitle") }}
        </p>
        <wegow-chat
          :chat-id="event.chat"
          class="mt-6"
          :check-follow-user="checkFollowerUser"
          @update-event="updateEvent()"
        />
      </section>
      <smart-intxt v-if="showAds" class="two-col" :type="'smartIntxt'" />
      <!-- Gallery Section -->
      <section
        v-if="geValidMedias(media)?.length"
        class="section-container two-col relative"
        :class="{
          'no-paddings': windowWidth < 475
        }"
      >
        <h3
          class="h3-titles xs:pl-0 pl-[0.813rem]"
          :class="{ 'has-show-more': geValidMedias(media)?.length > 3 }"
        >
          {{ $t("profiles.titles.gallery") }}
        </h3>
        <button
          v-if="geValidMedias(media)?.length > 3"
          class="text-color-topaz-light text-sm pl-3 md:pl-0"
          @click="showGalleryModal = true"
        >
          {{ $t("general.header.dropdown.showAll") }}
        </button>
        <div class="relative">
          <gallery-section :images="geValidMedias(media)" :navigation="false" />
          <div class="slider-gradient"></div>
        </div>
      </section>

      <!-- Accomodation -->
      <section
        v-if="completeLoaded && event.venue.longitude && event.venue.latitude"
        id="event-accommodation"
        class="section-container accommodation two-col md:p-0 p-2"
      >
        <accommodation-section
          :address="event.venue.address"
          :iso-code="event.city.iso_code"
          :location="{
            longitude: event.venue.longitude,
            latitude: event.venue.latitude
          }"
          :start-date="event.start_date"
        />
      </section>
      <smart-clip v-if="showAds" :type="'sc-top'" :type-aux="'sc-oop'" />
      <smart-clip v-if="showAds" :type="'sc-mpu-top'" />
      <!-- How to get -->
      <section
        id="how-to-get"
        class="section-container lg:h-[245px] h-fit how-to-get two-col md:p-0 p-2"
      >
        <h3 class="h3-titles title-underline">
          {{ $t("profiles.titles.howToGet") }}
        </h3>
        <div class="flex flex-col lg:flex-row">
          <div class="flex flex-col p-4 w-1/2">
            <div class="text-base font-museo-500 text-color-gray mt-4">
              <span>{{ event.venue.address }}</span>
              <Suspense>
                <template #default>
                  <div class="mt-2">
                    <modal-google-maps
                      :location="{
                        latitude: event.venue.latitude,
                        longitude: event.venue.longitude
                      }"
                      :title="event.venue.address"
                    />
                  </div>
                </template>
                <template #fallback>
                  <wegow-loader class="min-h-screen" />
                </template>
              </Suspense>
            </div>
            <!-- Public Transport -->
            <div v-if="event.venue.description">
              <span class="font-museo-500 h3-titles title-underline">{{
                $t("profiles.titles.publicTransport")
              }}</span>
              <div class="text-base font-museo-500 text-color-gray mt-4">
                <span>{{ event.venue.description }}</span>
              </div>
            </div>
          </div>
          <!-- Transport section-->
          <section
            id="transport-section"
            class="flex flex-col transport-btn lg:w-1/2"
          >
            <span
              class="font-museo-500 h3-titles title-underline md:hidden inline-block mb-8"
              >{{ $t("profiles.titles.transport") }}</span
            >
            <div class="flex-1 flex justify-center">
              <skyscanner></skyscanner>
            </div>
            <div class="blablacar flex-1 flex justify-center sm:justify-start">
              <blablacar></blablacar>
            </div>
          </section>
        </div>
      </section>
      <smart-clip v-if="showAds" :type="'sc-superbanner-btf'" />
      <smart-clip v-if="showAds" :type="'sc-mpu-btf'" />
      <dynamic-ad
        v-if="
          showAds &&
            windowWidth > 768 &&
            event.ads &&
            event.ads['desktop_event_dynamic'] &&
            event.ads[`desktop_event_intext`] === null
        "
        :values="event.ads['desktop_event_dynamic'].values"
      />
      <buy-banner />
    </template>
  </profile-layout>
  <div v-else-if="!eventError">
    <wegow-loader class="min-h-screen" />
  </div>
  <not-found v-else :show-layout="false" />
  <Suspense>
    <template #default>
      <ShareModal
        v-if="openShareVar"
        category="event"
        @close="openShareVar = false"
      ></ShareModal>
    </template>
    <template #fallback>
      <wegow-loader class="min-h-screen" />
    </template>
  </Suspense>
  <modal-profiles
    v-if="showFollowersModal"
    :title="
      `${event.followers_count} ${$t(
        'profiles.labels.followers'
      ).toLowerCase()}`
    "
    type="modal-large"
    @close="showFollowersModal = false"
  >
    <template #modalProfile>
      <section
        v-for="profile in eventFollowers"
        :key="profile.id"
        class="xs:block hidden"
      >
        <profile-card :profile="profile" type="profile-sm-card" />
      </section>
      <section
        v-for="user in eventFollowers"
        :key="user.id"
        class="xs:hidden block"
      >
        <user-card :user="user" />
      </section>
    </template>
  </modal-profiles>
  <modal-profiles
    v-if="showGalleryModal"
    :title="$t('profiles.titles.gallery')"
    type="medium"
    @close="(showGalleryModal = false), (showPrincipal = false)"
  >
    <template #modalProfile>
      <gallery-section
        :images="geValidMedias(media)"
        :navigation="false"
        type="venue"
        :modal="true"
      />
    </template>
  </modal-profiles>
</template>

<script setup>
import FbPixel from "@/components/general/FbPixel.vue";
import TiktokPixel from "@/components/general/TiktokPixel.vue";
import TwitterPixel from "@/components/general/TwitterPixel.vue";
import GaPixel from "@/components/general/GaPixel.vue";
import WegowButton from "@/components/general/forms/WegowButton.vue";
import ProfileLayout from "@/components/general/ui/profiles/ProfileLayout.vue";
import WegowLoader from "@/components/general/ui/WegowLoader.vue";
import Icon from "@/components/general/ui/elements/WIcon.vue";
import ProfileCard from "@/components/wegow/ui/cards/ProfileCard.vue";
import UserCard from "@/components/general/ui/UserCard.vue";
import DynamicAd from "@/components/general/ads/smartclip/DynamicAd.vue";
import SmartIntxt from "@/components/general/ads/smartclip/SmartIntxt.vue";
import SmartClip from "@/components/general/ads/smartclip/SmartClip.vue";
import LiveNowSection from "@/components/wegow/event/LiveNowSection.vue";
import Skyscanner from "@/components/wegow/accommodations/SkyscannerComponent.vue";
import Blablacar from "@/components/wegow/accommodations/BlablacarComponent.vue";
import WegowChat from "@/components/general/forms/complex-forms/WegowChat.vue";
import ShowMore from "@/components/general/ui/elements/ShowMoreComponent.vue";
import NotFound from "@/views/general/NotFound";
import FollowersSection from "@/components/general/ui/profiles/FollowersSection.vue";
import ArtistsSection from "@/components/general/ui/profiles/ArtistsSection.vue";
import MinorRegulation from "@/components/general/ui/profiles/MinorRegulation.vue";
import RelatedEvents from "@/components/general/ui/profiles/RelatedEvents.vue";
import RelatedArtists from "@/components/general/ui/profiles/RelatedArtists.vue";
import RelatedVenues from "@/components/general/ui/profiles/RelatedVenues.vue";
import ExternalOptionsList from "@/components/wegow/purchase/ExternalOptionsList";
import SingleExternalPurchaseButton from "@/components/wegow/purchase/SingleExternalPurchaseButton";
import BuyBanner from "@/components/wegow/purchase/BuyBanner";

import { useStatsStore } from "@/stores/modules/stats";
import { useUserStore } from "@/stores/modules/user";

import { useArtist } from "@/composables/useArtist";
import { useCookie } from "@/composables/useCookies";
import { useEvent } from "@/composables/useEvent";
import { usePurchase } from "@/composables/usePurchase";
import { useUser } from "@/composables/useUser";
import { useVenue } from "@/composables/useVenue";
import { ROUTE_VALUES } from "@/constants.js";
import { formatCurrency } from "@/plugins/currency";
import {
  formatSocialMedia,
  formatSocialMediaUrl
} from "@/plugins/social-media-formater";
import {
  formatHour,
  formatLongDate,
  formatDayWeekDate
} from "@/plugins/date-formater";
import { useModalHandler } from "@/plugins/useModalHandler";
import {
  computed,
  defineAsyncComponent,
  onBeforeMount,
  onMounted,
  ref,
  watch
} from "vue";
import { useI18n } from "vue-i18n";
import { onBeforeRouteUpdate, useRoute, useRouter } from "vue-router";
import { VueCookieNext } from "vue-cookie-next";
import { metas } from "@/plugins/mixins/metas";
import moment from "moment";
import WShadow from "@/components/general/ui/WShadow.vue";
import { event as tagEvent } from "vue-gtag";

const ModalProfiles = defineAsyncComponent(() =>
  import("@/components/general/modals/ModalProfiles.vue")
);

const { SIGN_IN, openModal, openErrorModal } = useModalHandler();
const {
  details: event,
  // defaultChannels,
  media,
  eventsRelatedToEvent,
  getEventMedia,
  getEventChannels,
  getDetails,
  getEventsRelatedToEvent,
  deleteAdRelatedToEvent,
  followEvent,
  unfollowEvent,
  hasCulturalBonus
} = useEvent();
const { setReference } = usePurchase();
const { artistsRelatedToEvent, getArtistsRelatedToEvent } = useArtist();
const {
  eventFollowers,
  userDetail,
  isAuth,
  init,
  getEventFollowers,
  selectedRegion
} = useUser();
const { venuesRelatedToEvent, getVenuesRelatedToEvent } = useVenue();
const { accepted } = useCookie();
const SocialMedia = defineAsyncComponent(() =>
  import("@/components/general/ui/elements/SocialMediaComponent.vue")
);
const ShareModal = defineAsyncComponent(() =>
  import("@/components/general/modals/ModalShare.vue")
);
const ModalReport = defineAsyncComponent(() =>
  import("@/components/general/modals/ModalReport.vue")
);
const ModalGoogleMaps = defineAsyncComponent(() =>
  import("@/components/general/modals/ModalGoogleMaps.vue")
);
const AccommodationSection = defineAsyncComponent(() =>
  import("@/components/wegow/event/AccommodationSection.vue")
);
const GallerySection = defineAsyncComponent(() =>
  import("@/components/wegow/ui/GallerySection.vue")
);
const router = useRouter();
const route = useRoute();
const { t } = useI18n();
const openShareVar = ref(false);
const loaded = ref(false);
const completeLoaded = ref(false);
const referenceQuery = ref({});
const timezone = ref("Europe/Madrid");
const isStreaming = ref(false);
const showLiveNow = ref(false);
const windowWidth = ref(0);
const $cookie = VueCookieNext;
const specialEvents = ref([5818688, 5818685, 5818689]);
const sunto = ref("");
const showFollowersModal = ref(false);
const showGalleryModal = ref(false);
const isArtist = ref(false);
const openArtist = ref(true);
const checkFollowerUser = ref(false);
const isChatEnabled = computed(
  () =>
    isAuth &&
    event.value.show_chat &&
    (userDetail.value?.is_staff || process.env.VUE_APP_CHAT_ENABLED === "true")
);
const imgIndex = ref(0);
const eventError = ref(false);
const showPrincipal = ref(false);
const deletePadding = ref(false);
const isZero = ref(false);
const showAds = ref(false);

const statsStore = useStatsStore();
const userStore = useUserStore();

const initEvent = route =>
  (async route => {
    loaded.value = false;
    completeLoaded.value = false;
    metas.methods.setLanguage();
    metas.methods.setCanonical(route);

    if (route.params.slug !== event.value?.slug)
      await getDetails(route.params.slug);
    showAds.value = !event.value.hide_ads;
    if (event.value?.id) {
      // showAds.value = ![
      //   5865250,
      //   6127691,
      //   6087114,
      //   6145575,
      //   5983337,
      //   6090299
      // ].includes(event.value.id);
      if (event.value.queued_web) {
        window.location.href = event.value.queue_link;
        return;
      }
      // init(false);
      loaded.value = true;
      changeUrlToEventType(route);
      if (specialEvents.value.includes(event.value.id)) {
        try {
          var axel = Math.random();
          var a = axel * 10000000000000;
          switch (event.value.id) {
            case 5818688:
              sunto.value = "sunto00";
              break;
            case 5818685:
              sunto.value = "sunto0";
              break;
            case 5818689:
              sunto.value = "sunto000";
              break;
          }
          const iframeElement = document.createElement("iframe");
          iframeElement.src = `https://12987476.fls.doubleclick.net/activityi;src=12987476;type=sunt;cat=${
            sunto.value
          };dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${
            accepted.value
          };gdpr_consent=${$cookie.getCookie("euconsent-v2")};ord=${a}?`;
          iframeElement.width = "1";
          iframeElement.height = "1";
          iframeElement.frameBorder = "0";
          iframeElement.style.display = "none";
          document.body.prepend(iframeElement);
        } catch (e) {
          console.log("Error", e);
        }
      }

      // Metas
      let title = "",
        description = "";
      if (event.value.html_personalization) {
        title = event.value.html_personalization.head_title;
        description = event.value.html_personalization.head_meta_description;
      } else if (event.value.type === 0) {
        let artists = event.value.artists
          .map(artist => artist?.name)
          .join(", ")
          .toString();
        title = t("general.metas.concertTitle", {
          artists: artists.length !== 0 ? artists : event.value.title,
          venue: event.value.venue.name,
          city: event.value.city.name
        });

        description = t("general.metas.concertDescription", {
          artist: artists.length !== 0 ? artists : event.value.title,
          city: event.value.city.name,
          venue: event.value.venue.name
        });
      } else {
        title = t("general.metas.festivalTitle", {
          event_title: event.value.title
        });

        description = t("general.metas.festivalDescription", {
          festival: event.value.title
        });
      }

      metas.methods.setMetasHtml(
        {
          title: title,
          description: description,
          alternates: event.value.alternates,
          noIndex: !event.value.index
        },
        route,
        router
      );

      // Schema
      let schema = {
        "@context": "https://schema.org",
        "@type": event.value.type === 0 ? "MusicEvent" : "Festival",
        name: event.value.title,
        description: event.value.description,
        about: [],
        location: {
          "@type": "Place",
          name: event.value.venue?.name,
          address: {
            "@type": "PostalAddress",
            streetAddress: event.value.venue?.address,
            addressLocality: event.value.city?.name,
            addressRegion: event.value.city?.iso_code,
            addressCountry: event.value.city?.iso_code
          }
        },
        image: event.value.thumbnails || "@/assets/images/wegow-cabecera.webp",
        offers: {
          "@type": "Offer",
          url: event.value.canonical,
          price: event.value.price !== null ? event.value.price : undefined,
          priceCurrency:
            event.value.currency !== null ? event.value.currency : undefined,
          availability: "https://schema.org/InStock",
          validFrom:
            moment(event.value.start_date).format("YYYY-MM-DD") +
            " " +
            hourFormatted.value
        },
        startDate:
          moment(event.value.start_date).format("YYYY-MM-DD") +
          " " +
          hourFormatted.value,
        endDate:
          moment(event.value.end_date).format("YYYY-MM-DD") +
          " " +
          hourFormatted.value,
        eventAttendanceMode: "https://schema.org/OfflineEventAttendanceMode",
        eventStatus: eventSchemaStatus(),
        performer: {
          "@type": "PerformingGroup",
          name:
            event.value.artists.length > 0 ? event.value.artists[0].name : ""
        },
        organizer: {
          "@type": "Organization",
          name: "Wegow",
          url: "https://www.wegow.com"
        }
      };
      formattedArtist(schema);
      let script = document.createElement("script");
      script.type = "application/ld+json";
      script.innerHTML = JSON.stringify(schema);
      document.head.appendChild(script);

      // Open graph
      metas.methods.setOpenGraph({
        title: event.value.title,
        description: event.value.description,
        image: event?.value.thumbnails?.m_hor_dt
          ? event.value.thumbnails.m_hor_dt
          : event?.value.image_url
      });

      // Twitter graph
      metas.methods.setTwitterCard({
        title: event.value.title,
        description: event.value.description,
        image: event?.value.thumbnails?.m_hor_dt
          ? event.value.thumbnails.m_hor_dt
          : event?.value.image_url
      });
      let eadatalayer = document.getElementsByTagName("script");
      for (const script of eadatalayer) {
        if (script.innerText && script.innerText.includes("EA_call")) {
          script.parentNode.removeChild(script);
        }
      }
      // Eulerian
      let eulerianScript = document.createElement("script");
      eulerianScript.type = "text/javascript";
      eulerianScript.text = `
        (function(e,a){var i=e.length,y=5381,k='script',s=window,v=document,o=v.createElement(k);for(;i;){i-=1;y=(y*33)^e.charCodeAt(i)}y='_EA_'+(y>>>=0);(function(e,a,s,y){s[a]=s[a]||function(){(s[y]=s[y]||[]).push(arguments);s[y].eah=e;};}(e,a,s,y));i=new Date/1E7|0;o.ea=y;y=i%26;o.async=1;o.src='//'+e+'/'+String.fromCharCode(97+y,122-y,65+y)+(i%1E3)+'.js?2';s=v.getElementsByTagName(k)[0];s.parentNode.insertBefore(o,s);})
        ('kvcn.wegow.com','EA_call');

        EA_datalayer = [
          "profile", "looker",
          "prdref", "${event.value.id}"
        ];

        EA_call(EA_datalayer);
      `;
      document.head.appendChild(eulerianScript);

      windowWidth.value = window.innerWidth;

      let promises = [];
      let promiseFollowers = getEventFollowers(event.value);
      let promiseRelatedEvents = getEventsRelatedToEvent(
        event.value,
        showAds.value
      );
      let promiseRelatedArtists = getArtistsRelatedToEvent(event.value);
      let promiseRelatedVenues = getVenuesRelatedToEvent(event.value);
      let promiseEventMedia = getEventMedia(event.value);
      isStreaming.value = event.value.attendance === 2;
      if (event.value.attendance !== 1) {
        let promiseEventChannels = getEventChannels(event.value);

        promises = [
          promiseFollowers.catch(e => e),
          promiseRelatedEvents.catch(e => e),
          promiseRelatedArtists.catch(e => e),
          promiseRelatedVenues.catch(e => e),
          promiseEventMedia.catch(e => e),
          promiseEventChannels.catch(e => e)
        ];
        await Promise.all(promises);

        let now = moment(),
          startDate = moment(event.value.start_date),
          endDate = moment(
            event.value.end_date ? event.value.end_date : event.value.start_date
          ).add(4, "hours");
        if (now.isAfter(startDate) && now.isBefore(endDate)) {
          showLiveNow.value = true;
        }
      } else {
        promises = [
          promiseFollowers.catch(e => e),
          promiseRelatedEvents.catch(e => e),
          promiseRelatedArtists.catch(e => e),
          promiseRelatedVenues.catch(e => e),
          promiseEventMedia.catch(e => e)
        ];
        await Promise.all(promises);
      }
      if (route.query.r) {
        tagEvent(route.query.r, {
          id: event.value.id,
          title: event.value.title,
          type: event.value.type === 0 ? "Concert" : "Festival"
        });
        referenceQuery.value.query = { r: route.query.r };
        setReference(route.query.r);
      }
      if (route.hash) {
        referenceQuery.value.hash = route.hash;
      }

      timezone.value = (await Intl.DateTimeFormat())
        .resolvedOptions()
        .timeZone.trim();
      completeLoaded.value = true;
    } else {
      loaded.value = true;
      eventError.value = true;
      metas.methods.setIndex(false);
    }
  })(route).catch(e => {
    console.log("error", e);
    loaded.value = true;
    eventError.value = true;
    metas.methods.setIndex(false);
  });

onBeforeMount(() => {
  initEvent(route);
  window.removeEventListener("resize", updateScreen);
});
onBeforeRouteUpdate(to => initEvent(to));
onMounted(async () => {
  window.addEventListener("resize", updateScreen);
  await sendStats();
  await router.isReady();
});

const sendStats = async () => {
  // Enviamos los datos para las stats
  const params = {
    campaign: "page_view",
    id: userStore.userDetail.unsubscribe_token
      ? userStore.userDetail.unsubscribe_token
      : sessionStorage.tt_sessionId,
    uri: route.fullPath,
    pageName: route.name
  };
  if (!window.location.href.includes("wegowlocal")) {
    await statsStore.sendToStatsService(params);
  }
};

const updateScreen = () => {
  windowWidth.value = window.innerWidth;
};

const changeUrlToEventType = route => {
  let newUrl = route.path;
  if (
    event.value.type === 0 &&
    ROUTE_VALUES.festivalStrinigs.some(elemento => {
      return route.path.includes("/" + elemento + "/");
    })
  ) {
    for (let i = 0; i < ROUTE_VALUES.festivalStrinigs.length; i++) {
      let regex = new RegExp(
        "\\b" + "/" + ROUTE_VALUES.festivalStrinigs[i] + "/" + "\\b",
        "g"
      );
      newUrl = newUrl.replace(
        regex,
        "/" + ROUTE_VALUES.concertStrinigs[i] + "/"
      );
    }
    history.pushState(null, null, newUrl);
  } else if (
    event.value.type === 1 &&
    ROUTE_VALUES.concertStrinigs.some(elemento => {
      return route.path.includes(elemento);
    })
  ) {
    for (let i = 0; i < ROUTE_VALUES.concertStrinigs.length; i++) {
      let regex = new RegExp(
        "\\b" + "/" + ROUTE_VALUES.concertStrinigs[i] + "/" + "\\b",
        "g"
      );
      newUrl = newUrl.replace(
        regex,
        "/" + ROUTE_VALUES.festivalStrinigs[i] + "/"
      );
    }
    history.pushState(null, null, newUrl);
  }
};

const geValidMedias = mediaImg => {
  if (mediaImg?.length > 0) {
    const thumbnails = { ...event.value?.thumbnails };
    const principal = {
      id: -1,
      name: "principal",
      description: "imagen principal",
      thumbnails: thumbnails,
      type: 0,
      video_url: ""
    };
    let filterImg = mediaImg.filter(m => m.type === 1 || m.thumbnails);
    if (showPrincipal.value && showGalleryModal.value) {
      filterImg.unshift(principal);
    }
    return filterImg;
  } else {
    return [];
  }
};
const primaryOptionsZero = options => {
  isZero.value = options.some(
    option => option.price === null || option.price === "0.00"
  );
};
const isExternal = computed(() => {
  return event.value.has_options && event.value.options.length > 0;
});
const startEventDate = computed(() => {
  const date = formatDayWeekDate(event.value.start_date, selectedRegion());
  return t("profiles.startDate", {
    weekday: date.dayweek,
    monthday: date.day,
    dayformat: selectedRegion() === "en" ? date.sufix : "",
    month: date.month,
    year: date.year,
    hour: date.hour
  });
});
const formattedArtist = schema => {
  for (const artist of event.value.artists) {
    schema.about.push({
      "@type": "MusicGroup",
      name: artist.name
    });
  }
};
const deleteConcertsWord = computed(() => {
  if (event.value.id === 6084173 || event.value.id === 6093363) {
    return true;
  } else {
    return false;
  }
});

const sameDateFestival = computed(() => {
  const startDate = moment(event.value.start_date.split("T")[0]).format(
    "DD-MM-YYYY"
  );
  const endDate = moment(event.value.end_date.split("T")[0]).format(
    "DD-MM-YYYY"
  );
  return startDate === endDate;
});
const openShareModal = () => {
  openShareVar.value = !openShareVar.value;
};

watch(route, async (newValue, _oldValue) => {
  await getDetails(newValue.params.slug);
  if (event.value) {
    // TODO. añadir falso
    // await getEventFollowers(event.value);
    await getEventsRelatedToEvent(event.value, showAds.value);
    await getArtistsRelatedToEvent(event.value);
    await getVenuesRelatedToEvent(event.value);
  } else {
    // TODO: adir redireccon a pagina de error
    // next("/NotFound");
  }
});

const nameFormatted = computed(() => {
  let title = event.value.title || "";
  title = title.replace(t("wegow.headerDetails.start"), "");
  title = title.replace(t("wegow.headerDetails.startStreaming"), "");
  return title.replace(
    t("wegow.headerDetails.in", {
      city: event.value.city?.name || event.value.city?.administrative_division
    }),
    ""
  );
});

const interested = async event => {
  if (event.user.tracking) {
    await unfollowEvent(event);
  } else {
    await followEvent(event);
  }
  await getDetails(route.params.slug);
};

const scrollToSection = id => {
  const element = document.getElementById(id);
  window.scrollTo({
    top: element.offsetTop,
    behavior: "smooth"
  });
};

const sendGa = label => {
  // if (this.$gtag && typeof this.$gtag.event === "function")
  //   this.$gtag.event("click", {
  //     event_category: label
  //   });
};
const updateEvent = async () => {
  checkFollowerUser.value = true;
  initEvent(route);
};

const priceFormatted = computed(
  () =>
    formatCurrency(Number(event.value.price).toFixed(2), event.value.currency)
  // TODO: revisar si es necesario el fixed y el number
);

const longDateFormated = computed(() => {
  let infoDate = formatLongDate(
    event.value.start_date,
    selectedRegion(),
    isStreaming.value
  );
  return t("wegow.date.dateFormat", infoDate);
});

const longEndDateFormated = computed(() => {
  let infoDate = formatLongDate(
    event.value.end_date,
    selectedRegion(),
    isStreaming.value
  );
  return t("wegow.date.dateFormat", infoDate);
});

const hourFormatted = computed(() =>
  formatHour(event.value.start_date, route.params.region, isStreaming.value)
);
const hourOpenFormatted = computed(() =>
  formatHour(event.value.opening_hour, route.params.region, isStreaming.value)
);

const artistsInvited = computed(() =>
  event.value.artists.map(artist => artist?.name).join(", ")
);

const isFestival = computed(() => event.value.type === 1);
const orderArtists = computed(() => {
  return event.value.artists.slice().sort((a, b) => {
    return b.followers_count - a.followers_count;
  });
});
const eventSchemaStatus = () => {
  if (event.value.closed || event.value.cancelation_status !== 0) {
    return "https://schema.org/EventCancelled";
  } else {
    return "https://schema.org/EventScheduled";
  }
};
watch(
  windowWidth,
  newWidth => {
    updateScreen();
  },
  { immediate: true }
);

const onClickQueued = event => {
  if (event.has_waiting_room) {
    window.open(event.queue_link, "_blank");
  } else {
    window.open(event.purchase_url, "_self");
  }
};
</script>
<style lang="scss" scoped>
@import "@/components/general/ui/profiles/profiles.scss";
@import "~@/assets/mixins/delete-scroll.scss";

// TODO: Cambiar a left-section

.info {
  span:not(.text-topaz-light) {
    @apply text-xs font-museo-300;
    color: white;
  }
}

.like {
  cursor: pointer;
}

.address-title {
  font-size: 20px;

  ~ div > span {
    font-size: 18px;
  }
}

.event-status {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 80px;
  min-height: 42px;
  position: absolute;
  right: 10px;
  top: 10px;
  background: #1c1d29;
  opacity: 80%;
  padding: 12px 16px;

  &.cancel {
    background: red;
  }
}
.related-title {
  font-size: 16px;
  margin-bottom: 14px;
  @media screen and (min-width: $screen-md) {
    font-size: 20px;
    margin-bottom: 14px;
  }
}

// .accommodation,
// .how-to-get {
//   max-width: 1040px;
//   @media screen and (min-width: $screen-md) {
//     width: 86%;
//     margin-right: auto;
//     margin-left: auto;
//   }
// }
.how-to-get {
  margin-bottom: 14px;
}
header a {
  margin-right: 0 !important;
}

#description {
  font-size: 12px;
  @media screen and (min-width: $screen-md) {
    font-size: 1rem;
  }
  @apply text-color-gray;
}
.is-external {
  max-height: 900px;
  min-height: fit-content;
  @include delete-scroll;
}
.no-wegow-tickets-mobile {
  min-height: 120px;
  color: $textSubtitle;
}
.artist-gradient {
  background: linear-gradient(
    180deg,
    rgba(181, 181, 181, 0) 30%,
    $backgroundBlack 100%
  );
  height: 55%;
}
</style>
